module.exports = {"flags":[{"x":50,"y":180,"mobile":true},{"x":90,"y":730,"mobile":true},{"x":180,"y":400,"mobile":true},{"x":426,"y":180,"mobile":true},{"x":400,"y":600,"mobile":true},{"x":485,"y":622,"mobile":true},{"x":530,"y":78,"mobile":true},{"x":500,"y":400,"mobile":true},{"x":1130,"y":360,"mobile":true},{"x":1194,"y":116,"mobile":true},{"x":1260,"y":530,"mobile":true},{"x":1282,"y":550,"mobile":true},{"x":1400,"y":379,"mobile":true}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/flags-data.json
// module id = 452
// module chunks = 0